<template>
  <div class="flex-1 editable-box" :class="tableComplu?'':'relative'">
    <div
      ref="container" 
      :contenteditable="contenteditable"
      placeholder="请插入字段及函数完成计算表达式"
      class="edit-div flex-1 px-2 py-1 leading-base outline-none"
      @blur="onBlur"
      @focus="onFocus"
      @keyup="onConfirm"
    ></div>
    <div v-show="showTool" class="flex items-center tool-box" @mousedown.prevent>
      <el-popover
        placement="bottom"
        width="252"
        trigger="manual"
        popper-class="index-set-tool-popover"
        v-model="quesPopoverVisiable"
        :visible-arrow="false"
        @hide="hideOptionList"
        >
        <!-- <div></div> -->
        <div @mousedown.prevent class="list-container" v-show="questionList.length>0">
         <div v-for="(q,i) of questionList" :key="q.id" @click="changeQuestion(q,i)">
          <el-popover
            placement="right-start"
            width="150"
            trigger="manual"
            v-model="q[positionType]"
            :visible-arrow="false"
            popper-class="index-set-option-tool-popover"
            >
            <!-- <div></div> -->
            <div @mousedown.prevent :ref="`popover-${q.id}`">
              <div 
                v-for="(o,index) of optionList" 
                :key="o.id" @click="changeOption(q,o,index)" 
                class="item flex itens-center justify-content" 
                :class="selectIdList.includes(o.id)?'active':''"
              >
                <div class="title">{{o.content.text}} </div>
                <i v-show="selectIdList.includes(o.id)" class="el-icon-check"></i>
             </div>
            </div>
            <div slot="reference">
              <div class="item flex itens-center justify-content" :class="q.id==selectQuestion.id?'active':''">
                <div class="title">{{q.content.text}}</div> <i v-show="q.question_type!=7" class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-popover>
         </div>

        </div>
        <div class="text-medium text-theme-black-550 leading-34 font-normal"  v-show="questionList.length==0">无数据</div>
        <span slot="reference" class="text-white cursor-pointer" @click="quesPopoverVisiable=true;funListVisiable=false">插入字段</span>
      </el-popover>
      <div class="splice"></div>
      <el-popover
        placement="bottom"
        width="200"
        trigger="manual"
        popper-class="index-set-fun-tool-popover"
        :visible-arrow="false"
        v-model="funListVisiable"
        >
        <!-- <div></div> -->
        <div @mousedown.prevent class="list-container">
         <div v-for="f of funList" :key="f" @click="changeFun(f)" class="item" :class="funName==f?'active':''">
            {{f}}
         </div>
        </div>
        <span slot="reference" class="text-white cursor-pointer" @click="funListVisiable=true;quesPopoverVisiable=false">插入函数</span>
      </el-popover>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator('+')">+</div>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator('-')">-</div>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator('*')">*</div>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator('/')">/</div>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator('(')"> ( </div>
      <div class="splice"></div>
      <div class="text-white cursor-pointer" @click="insertOperator(')')"> ) </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {getSurveyPreview } from '@/api/wenjuan/wjquestion'
import { html2text } from '@dygc/shared'
import { convertQuestionList } from '@/question/factory'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ComplexCalculation',
  components: {},
  data() {
    return {
      showTool:false,
      funList:['SUM','AVERAGE','COUNT'],
      funName:'',
      checkQuestionTypeList:[1,2,27,32,34,37,38,39,40],
      questionList:[],
      allQuestionList:[],
      optionList:[],
      selection:null,
      range:null,
      parentNode:null,
      selectQuestion:{},
      selectList:[],
      isConfirmIng:false,
      quesPopoverVisiable:false,
      funListVisiable:false,
    }
  },
  props: {
    initialValue: {
      type: String,
      default: ''
    },
    timeSurveyId:{
      type: String,
      default: ''
    },
    contenteditable:{
      type: Boolean,
      default: true,
    },
    initialValueText: {
      type: Object,
      default: () => ({})
    },
    tableComplu:{
      type: Boolean,
      default: false,
    },
    positionType:{
      type: String,
      default: 'simple'
    }
  },
    watch: {
      timeSurveyId(){
        this.initQuestionList()
      },
      initialValue(val,old){
        this.changeInsertContent(val)
      },
      
  },
computed:{
  ...mapGetters(['indexSurveyInfoList']),
  selectIdList(){
    return this.selectList.map(val=>val.id)
  }
},
 async mounted(){
   await this.initQuestionList()
    if(this.initialValue){
      this.changeInsertContent(this.initialValue)
    }
  },
  methods:{
    changeInsertContent(formalHtml){
      let innerHTML = formalHtml
      let HTML=this.$refs.container.innerHTML
      if(HTML==innerHTML)return
      let reg= /\${{question(.+?)\}}/g
      let newValue=innerHTML.match(reg)
      if(newValue){
        newValue.forEach(val=>{
        let question = val.match(/\question(\d+)/)
        let answer = val.match(/\answer(\d+)/g)
        let newVal=val
        let ques={}
        this.allQuestionList.forEach((val)=>{
          if(val.id==question[1]){
            ques=val
          }
        })
        let answerList=[]
        if(answer){
          let answerArr=answer.map(a=>a.slice(6))
         ques.issue.items.forEach((item,i)=>{
          if(answerArr.includes(item.id)){
            answerList.push(`选项${i+1}`)
          }
         })
         newVal=`[Q${ques.num}_`+answerList.join('&')+']'
        }else{
          newVal=`[Q${ques.num}]`
        }
        innerHTML=innerHTML.replace(val,newVal)
        })
      }
      this.$nextTick(() => {
      this.$refs.container.innerHTML = innerHTML
    })
    },
    async initQuestionList(){
      let surveyId=this.timeSurveyId
      const list=this.indexSurveyInfoList[surveyId]
      if(!list){
       await getSurveyPreview(surveyId).then(res=>{
          const { code, data } = res.data
          if (code === 0) {
            const list=data?.pageQuestions || []     
            const qlist = convertQuestionList(list)
            this.$store.commit('SET_INDEX_SURVRY_INFO_LIST',Object.assign(this.indexSurveyInfoList || {},{[surveyId]:qlist}))
            this.allQuestionList=qlist
            this.questionList=qlist.filter(val=>this.checkQuestionTypeList.includes(val.question_type) || (val.question_type==7 && val.issue.validate=='num'))
          }else{
            this.allQuestionList=[]
            this.questionList = []
          }
        })
      }else{
        this.allQuestionList=list
        this.questionList=list.filter(val=>this.checkQuestionTypeList.includes(val.question_type) || (val.question_type==7 && val.issue.validate=='num'))
      }
      this.selectQuestion={}
      this.selectList=[]
    },
    onBlur(event) {
      // event.target.focus()
      this.showTool=false
      this.quesPopoverVisiable=false
      this.funListVisiable=false
      this.selectQuestion={}

    },
    onFocus(){
      this.showTool=true
    },
    changeQuestion(q,i){
      this.selectQuestion=q
      this.selectList=[]
      this.questionList.map(val=>{val[this.positionType]=false})
      if(this.checkQuestionTypeList.includes(q.question_type)){
        this.optionList=cloneDeep(q.issue.items)
        this.questionList[i][this.positionType]=true
        this.selectQuestion.text=`[Q${q.num}_`
      }else{
        this.optionList=[]
        this.selectQuestion.text=`[Q${q.num}]`
        this.questionList[i][this.positionType]=false
        this.quesPopoverVisiable=false
      }
    },
    hideOptionList(){
      this.questionList.map(val=>{val[this.positionType]=false})
      if(!this.selectQuestion.id) return
      if(this.selectQuestion.question_type==7){
        const insertText=this.selectQuestion.text
        this.inSetField(insertText)
      }else{
        if ( this.selectList.length==0) return
        let insertText=this.selectQuestion.text
        this.selectList.forEach((val,i)=>{
          i==0?insertText+=`选项${1+val.index}`:insertText+=`&选项${1+val.index}`
         })
         insertText+=']'
        this.inSetField(insertText)
      }
    },
    changeOption(q,o,index){
        if(q.question_type==2){
          o.active=!o.active
          this.selectList=[]
          this.optionList.forEach((val,i)=>{
            if(val.active){
              this.selectList.push({id:val.id,index:i})
            }
          })
        }else{
          this.selectList=[{id:o.id,index:index}]
        }
      this.quesPopoverVisiable=false
    },
    inSetField(insertText){
      this.selectQuestion={}
      this.selectList=[]
      const selection = window.getSelection && window.getSelection()
      const range = selection.getRangeAt(0)
      const parentNode = selection.anchorNode.parentElement
      let span = document.createElement('span')
      span.setAttribute('ref', 'insertSpan')
      span.append(document.createTextNode(insertText))
      span.contentEditable = 'false'
      range.insertNode(span)
      selection.collapseToEnd()
      this.onConfirm()
    },
    changeFun(f){
      //获取当前光标位置
      const selection = window.getSelection && window.getSelection()
      const range = selection.getRangeAt(0)
      // const parentNode = selection.anchorNode.parentElement
      // 添加函数及括号
      let span1 = document.createElement('span')
      span1.append(document.createTextNode(')'))
      span1.contentEditable = 'false'
      range.insertNode(span1)
      let span2 = document.createElement('span')
      span2.append(document.createTextNode('('))
      span2.contentEditable = 'false'
      range.insertNode(span2)
      let span3 = document.createElement('span')
      span3.append(document.createTextNode(f))
      span3.contentEditable = 'false'
      range.insertNode(span3)
      // 光标移动到选区最后
      selection.collapseToEnd()
      // 获取新的光标位置
      let NewSelection=window.getSelection && window.getSelection()
      // 移动光标到括号内
      let offset=NewSelection.focusOffset-1
      let container=this.$refs.container
      NewSelection.extend(container,offset)
      NewSelection.collapseToStart()
      // 关闭下拉列表
      this.funListVisiable=false
      this.onConfirm()
    },
    insertOperator(operator){
      let span = document.createElement('span')
      span.append(document.createTextNode(operator))
      span.contentEditable = 'false'
      let selection = window.getSelection && window.getSelection()
      let range = selection.getRangeAt(0)
      range.insertNode(span) 
      selection.collapseToEnd()
      this.onConfirm()
    },
    onConfirm() {
      let innerHTML=this.$refs.container.innerHTML
      this.$emit('update:initialValue',innerHTML)
    },
    
  }
}
</script>

<style lang="scss" scoped>

.tool-box{
  position: absolute;
  height:26px;
  // top: -23px;
  // left:20px;
  font-size: 12px;
  color: #fff;
  padding: 0px 8px;
  @apply bg-theme;
  z-index: 10;
  transform: translate(10px,-60px);
  .splice{
    width: 1px;
    height: 8px;
    margin-left: 8px;
    margin-right: 8px;
    background-color: #fff;

  }
}
.edit-div{
  &:empty::before {
      content: attr(placeholder);
      font-weight: 400;
      font-size: 14px;
      color: #C4C7CF;
      line-height: 22px;
    }
}
.list-container{
  padding: 8px 0px;
  background-color: #fff;

}

.item{
  padding: 8px 12px;
  // width: 100%;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  .title{
    width: 204px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:hover{
    background-color: #F2F5FA;
  }
}
.active{
  background-color: #F2F5FA;
  @apply text-theme;
}
</style>
<style lang="scss">
.index-set-tool-popover,.index-set-option-tool-popover,.index-set-fun-tool-popover{
  padding: 0;
}
.index-set-option-tool-popover:has(.hidden-detail){
  display: none;
}
</style>